import { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { LeftArrow } from 'assets/icons/components/index'
import { setMainContent } from 'actions'
let logo = '/images/logo.png'
import { useTranslation, Trans } from 'react-i18next'
import i18n from 'config/i18n'
import Markdown from 'markdown-to-jsx'
import { AppConfigServices } from 'services'

const AboutUs = (props) => {
  const { dispatch, user } = props
  const { t } = useTranslation('live', { i18n })
  const [ data, setData ] = useState({})

  const back = () => {
    dispatch(setMainContent('dashboard'))
  }

  useEffect(() => {
    getContent()
  }, [])

  const getContent = async () => {
    const { data } = await AppConfigServices.getPage('chat_rules', user?.language || 'en')

    setData(data)
  }

  return (
    <div className='main-content__about-us'>
      <div className='about-us__header'>
        <div className='header__heading'>{t('Chat rules')}</div>
        <div className='header__icon' onClick={() => back()}>
          <LeftArrow className='icon__icon' />
        </div>
      </div>
      <div className='about-us__container'>
        <div className='container__logo' >
          <img className='logo__image' src={logo} />
        </div>
        <div className='container__version'>
          Chat rules
        </div>
        <div className='container__about-description'>
          <Markdown
            options={{
              namedCodesToUnicode: {
                '&#39;': "'",
              }
            }}
          >{data?.chat_rules?.content ? data?.chat_rules?.content : ''}
          </Markdown>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
  user: state.connectionReducer.user,
})

export default connect(mapStateToProps)(AboutUs)